.overlay {
	position: fixed;
	z-index: 1000;
	width: 100vw;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: color-mix(in srgb, var(--background-secondary), transparent 75%);
	outline: none;
}

.dialog {
	background-color: var(--elevation-default);
	width: fit-content;
	min-width: 400px;
	max-width: 500px;
	border-radius: 16px;
	padding: 20px;
	outline: none;
}

.content {
	margin-top: 16px;
	text-align: left;
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.header {
	display: flex;
	justify-content: space-between;
}

.header h2 {
	margin-top: 12px;
}

.actions {
	margin-top: 12px;
	display: flex;
	justify-content: left;
	gap: 8px;
}
